import {useCallback, useEffect, useState} from 'react'
import {serverPhoneFormat} from 'services/utils/apiUtils'
import {
    useSendSmsForSignupMutation,
    useVerifySmsMobileMutation,
    useVerifySmsSignupMutation,
} from 'store/Store'
import useTimerString from './useTimerString'

const useVerifySms = (isSignup) => {
    const [verifySmsError, setVerifySmsError] = useState()
    const [sendSmsError, setSendSmsError] = useState()
    const [ulth, setUlth] = useState()
    const [signupVerified, setSignupVerified] = useState(false)
    const [smsSent, setSmsSent] = useState(false)

    const {timeStr, startTime, resetTime} = useTimerString()

    const [doVerifySms, {isLoading, error}] = useVerifySmsMobileMutation()

    const [
        doVerifySmsSignup,
        {isLoading: isLoadingSignup, error: errorSignup},
    ] = useVerifySmsSignupMutation()

    const [
        doSendSmsForSignup,
        {isLoading: isLoadingSendSmsForSignup, error: errorSendSms},
    ] = useSendSmsForSignupMutation()

    const clearVerifySmsError = () => {
        setVerifySmsError(null)
        setSendSmsError(null)
    }

    useEffect(() => {
        const combinedError = error || errorSignup
        if (combinedError) {
            setVerifySmsError(combinedError.data || combinedError)
        }
    }, [error, errorSignup])

    useEffect(() => {
        if (errorSendSms) {
            setSendSmsError(errorSendSms.data)
        }
    }, [errorSendSms])

    const verifySms = useCallback(
        async ({phone, sms}) => {
            setUlth(null)
            setSignupVerified(false)
            let res
            const verifyData = {
                phone: serverPhoneFormat(phone),
                sms,
            }
            try {
                if (isSignup) {
                    res = await doVerifySmsSignup(verifyData)
                } else {
                    res = await doVerifySms(verifyData)
                }
                if (res?.data?.success) {
                    if (isSignup) {
                        setSignupVerified(true)
                    } else {
                        const newUlth = res.data.msg
                        setUlth(newUlth)
                        return newUlth
                    }
                }
            } catch (err) {
                setVerifySmsError(err)
            }
        },
        [doVerifySms, doVerifySmsSignup, isSignup]
    )

    const sendSms = useCallback(
        async ({phone}) => {
            setSmsSent(false)
            const res = await doSendSmsForSignup({
                phone: serverPhoneFormat(phone),
            })

            if (res?.data?.success) {
                setSmsSent(true)
            }
        },
        [doSendSmsForSignup]
    )

    return {
        doVerifySms: verifySms,
        doSendSms: sendSms,
        isLoading: isLoading || isLoadingSignup || isLoadingSendSmsForSignup,
        verifySmsError,
        sendSmsError,
        ulth,
        signupVerified,
        clearVerifySmsError,
        smsSent,
        startTime,
        resetTime,
        timeStr,
    }
}

export default useVerifySms
